import { Component } from '@angular/core';
import { ItemAttributesStoreService } from '../item-attributes-store.service';
import { ItemAttribute } from '../../../models/item';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmDialogComponent } from '../../dialogs/confirm-dialog/confirm-dialog.component';
import { take } from 'rxjs/operators';
import { AttributeValuePipe } from '../attribute-value.pipe';
import { AttributeValueTimestampUserPipe } from '../attribute-value-timestamp-user.pipe';
import { MatIcon } from '@angular/material/icon';
import { MatMenuTrigger, MatMenu, MatMenuItem } from '@angular/material/menu';
import { MatButton, MatIconButton } from '@angular/material/button';
import { KeyValuePairComponent } from '../../general/key-value-pair/key-value-pair.component';
import { NgFor, AsyncPipe } from '@angular/common';
import { TestIdDirective } from '../../directives/test-id.directive';

@Component({
    selector: 'app-attribute-list',
    templateUrl: './attribute-list.component.html',
    standalone: true,
    imports: [TestIdDirective, NgFor, KeyValuePairComponent, MatButton, MatIconButton, MatMenuTrigger, MatIcon, MatMenu, MatMenuItem, AsyncPipe, AttributeValueTimestampUserPipe, AttributeValuePipe]
})
export class AttributeListComponent {
  attributes$ = this.store.attributes$;

  constructor(
    private store: ItemAttributesStoreService,
    private dialoy: MatDialog
  ) {}

  updateAttributeValue(attribute: ItemAttribute) {
    this.store.switchToUpdateValueView(attribute);
  }

  addAttribute() {
    this.store.setView('create');
  }

  editAttribute(attribute: ItemAttribute) {
    this.store.switchToEditAttributeView(attribute);
  }

  deleteAttribute(attribute: ItemAttribute) {
    this.dialoy
      .open(ConfirmDialogComponent, {
        data: {
          title: 'Delete Attribute',
          message: `Are you sure you want to delete the attribute ${attribute.name}?`,
          type: 'delete'
        }
      })
      .afterClosed()
      .pipe(take(1))
      .subscribe((result) => {
        if (result) {
          this.store.deleteAttribute(attribute);
        }
      });
  }
}
